import { NgModule } from '@angular/core';
import { NbSidebarModule, NbThemeModule } from '@nebular/theme';

@NgModule({
  imports: [NbThemeModule.forRoot({ name: 'simba' }), NbSidebarModule.forRoot()],
})
export class AppThemeModule {}
